import APIclient from "API/Client";
import { GetOrgId } from "utility";

export const resetPassword = (data: any) => {
  return APIclient.postData("/api/v1/auth/changePassword", { organisation_id: GetOrgId(), ...data });
};
